<template>
<span>
<button :class="['btn', buttonClass]" :disabled="$_disabled" @click.prevent="_onClick">
    <span class="fa fa-spinner fa-spin" v-if="actionPending && showSpinner && (this.enableSpinnerByDefault || this.enableSpinner)">
    </span>
    <slot></slot>
</button>
</span>
</template>

<script>
import $ from "jquery";
import primitiveMixin from './primitive-mixin'

export default {
    mixins: [primitiveMixin],
    props: {
        onClick: { type: Function, required: false },
        enableSpinner: { type: Boolean, default: false }
    },
    data() {
        return {
            actionPending: false,
            showSpinner: false,
            buttonClass: null,
            defaultSpinnerButtons: ['Save', 'Create', 'Delete', 'Submit']
        }
    },
    computed: {
        enableSpinnerByDefault() {
          const btnText = this.$slots.default[0].text;
          return this.defaultSpinnerButtons.includes(btnText);
        },
        $_disabled() {
            return this.actionPending || this.disabled;
        },
    },
    mounted() {
        // move btn-class from the containing amf-button to the button
        var classes = this.$el.className.split(/\s+/);
        if (_.find(classes, c => c.startsWith("btn-"))) {
            this.buttonClass = _.find(classes, c => c.startsWith("btn-"));
            $(this.$el).removeClass(this.buttonClass);
        }

    },
    methods: {
        async _onClick() {
            const timer = setTimeout(() => this.showSpinner = true, 300);
            let result = this.onClick();
            if(result && result.then) {
                this.actionPending = true;
                result.finally(x => {
                    clearTimeout(timer);
                    this.showSpinner = false;
                    this.actionPending = false;
                });
            }
            else {
                this.$emit('click');
            }
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfButton.vue